import api from '@/services/Api'

// ----------------------------- o

const namespaced = true;

// ----------------------------- o

const state = {
    errors: {},
    loading: false,
    iframe: null,
    // cart: {},
    // orders: []
};

// ----------------------------- o

const getters = {

};

// ----------------------------- o

const actions = {
    'SHOP_GLASS_IFRAME_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('SHOP_GLASS_REQUEST');
            let url = 'shops';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('SHOP_GLASS_IFRAME', resp.data.data);
                    resolve(resp);
                })
                .catch(err => {
                    commit('SHOP_GLASS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    // 'SHOP_GLASS_CART_REQUEST': ({commit, dispatch}) => {
    //     return new Promise((resolve, reject) => {
    //         commit('SHOP_GLASS_REQUEST');
    //         let url = 'shops/carts';
    //         api({url: url, method: 'GET'})
    //             .then(resp => {
    //                 commit('SHOP_GLASS_CART_UPDATE', resp.data.data);
    //                 resolve(resp);
    //             })
    //             .catch(err => {
    //                 commit('SHOP_GLASS_ERROR', err.response.data.errors ? err.response.data.errors : []);
    //                 reject(err)
    //             })
    //     })
    // },
    // 'SHOP_GLASS_CART_PRODUCT_ADD': ({commit, dispatch}, payload) => {
    //     return new Promise((resolve, reject) => {
    //         commit('SHOP_GLASS_REQUEST');
    //         let url = 'shops/carts/' + payload.slug + '/add';
    //         api({url: url, method: 'GET'})
    //             .then(resp => {
    //                 dispatch('SHOP_GLASS_CART_REQUEST'); // update / recalculate cart
    //                 resolve(resp);
    //             })
    //             .catch(err => {
    //                 commit('SHOP_GLASS_ERROR', err.response.data.errors ? err.response.data.errors : []);
    //                 reject(err)
    //             })
    //     })
    // },
    // 'SHOP_GLASS_CART_PRODUCT_DELETE': ({commit, dispatch}, payload) => {
    //     return new Promise((resolve, reject) => {
    //         commit('SHOP_GLASS_REQUEST');
    //         let url = 'shops/carts/' + payload.slug + '/delete';
    //         api({url: url, method: 'GET'})
    //             .then(resp => {
    //                 dispatch('SHOP_GLASS_CART_REQUEST'); // update / recalculate cart
    //                 resolve(resp);
    //             })
    //             .catch(err => {
    //                 commit('SHOP_GLASS_ERROR', err.response.data.errors ? err.response.data.errors : []);
    //                 reject(err)
    //             })
    //     })
    // },
};

// ----------------------------- o

const mutations = {
    'SHOP_GLASS_REQUEST': (state) => {
        state.errors = {};
        state.loading = true;
    },
    'SHOP_GLASS_IFRAME' : (state, resp) => {
        state.iframe = resp;
        state.loading = false;
    },
    // 'SHOP_GLASS_CART_UPDATE' : (state, resp) => {
    //     state.cart = resp;
    //     state.loading = false;
    // },
    'SHOP_GLASS_ERROR': (state, resp) => {
        state.errors = resp;
        state.loading = false;
    },
};

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}
